// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2SEqX","header":"ReportDetails_header__RgS48","title":"ReportDetails_title__3WSfV","left":"ReportDetails_left__22D2H"};